import { gql } from '@apollo/client';

export const getSoPartner = gql`
  query soPartner($soId: String!) {
    soPartner(soId: $soId) {
      code
      name
    }
  }
`;
